import { EquipmentStatus } from './Const';

export const hideReturnToBranchStatus = (status: number) => {
  const statusToHide = [EquipmentStatus.Missing, EquipmentStatus.BeingRepaired, EquipmentStatus.NoLongerInService, EquipmentStatus.InTransit];
  const hideManage = statusToHide.includes(status);
  return hideManage;
};
